export default "__VITE_ASSET__R_5s4mXZ__"